import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import { all } from 'ramda'

import { Tooltip } from '@app/common/Components/Tooltip/Tooltip'
import { IModernSearchItem } from '@app/common/helpers/IModernSearchItem'
import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'
import { LawyerAnswer } from '@app/modules/Messages/Components/LawyerAnswer'
import { LawyerAuditReport } from '@app/modules/Messages/Components/LawyerAuditReport/LawyerAuditReport'
import { letterRequestContext } from '@app/modules/Messages/letterRequestContext'
import {
  getNoLetterAddedToAnswerWithoutReport,
  getNoLetterAddedToReport
} from '@app/modules/Messages/store/selectors'
import { Message } from '@app/queries/CustomerAsLawyer/models'

export interface ISelectedEmailTemplate {
  name: string
  content: string
  id: number
  categoryLawyer?: string | null
}

export interface IHandleEmailTemplateChange {
  label: string
  value: string
}

type Props = {
  lastQuestion: Message
  latestPurchase: string
  customer
  emailTemplates?: IModernSearchItem[]
  selectedEmailTemplate?: ISelectedEmailTemplate
  setSelectedEmailTemplate?: React.Dispatch<React.SetStateAction<ISelectedEmailTemplate | null>>
  handleEmailTemplateChange?: (props: IHandleEmailTemplateChange) => void
  forceAuditReport?: boolean
}

export const AnswerArea = ({
  lastQuestion,
  latestPurchase,
  customer,
  emailTemplates,
  selectedEmailTemplate,
  setSelectedEmailTemplate,
  handleEmailTemplateChange,
  forceAuditReport = false
}: Props) => {
  const { letterRequestData } = useContext(letterRequestContext)
  const hasAppointmentDate = lastQuestion.appointmentAt != null
  const defaultTabIndex = hasAppointmentDate ? 0 : 1
  const { id: latestMessageId } = lastQuestion
  const letterRequest = letterRequestData?.openLetterRequest ? true : false
  const noLetterAddedToAnswerWithoutReport = useSelector(getNoLetterAddedToAnswerWithoutReport)
  const noLetterAddedToReport = useSelector(getNoLetterAddedToReport)
  const letterRequestEnabled = useSelector(isFeatureEnabled(Features.REQUEST_LETTER_LAWYER))
  const customerWaitingForLetter = all(Boolean)([letterRequestEnabled, letterRequest])

  return (
    <div className='dialog-item-tabs'>
      <Tabs defaultIndex={defaultTabIndex} className='dialog-item-tabs__wrapper'>
        <TabList className='dialog-item-tabs__list'>
          <Tab
            className='dialog-item-tabs__list-item'
            disabledClassName='dialog-item-tabs__list-item--disabled'
            selectedClassName='dialog-item-tabs__list-item--selected'
            disabled={forceAuditReport}
          >
            <Tooltip
              message={
                'Für die erste schriftliche Beratung eines Kunden ist die Erstellung eines Prüfungsberichts Pflicht. Die Antworten-Funktion kann erst ab der zweiten Beratung genutzt werden.'
              }
              active={forceAuditReport}
            >
              Antworten
            </Tooltip>
          </Tab>
          <Tab
            className='dialog-item-tabs__list-item'
            disabledClassName='dialog-item-tabs__list-item--disabled'
            selectedClassName='dialog-item-tabs__list-item--selected'
          >
            Prüfungsbericht erstellen
          </Tab>
        </TabList>
        <div className='dialog-item-box'>
          <TabPanel>
            <LawyerAnswer
              handleEmailTemplateChange={handleEmailTemplateChange}
              selectedEmailTemplate={selectedEmailTemplate}
              setSelectedEmailTemplate={setSelectedEmailTemplate}
              emailTemplates={emailTemplates}
              latestMessageId={latestMessageId}
              lastQuestion={lastQuestion}
              customer={customer}
              requestedLetterNotAdded={
                customerWaitingForLetter && noLetterAddedToAnswerWithoutReport
              }
              latestPurchase={latestPurchase}
            />
          </TabPanel>
          <TabPanel>
            <LawyerAuditReport
              handleEmailTemplateChange={handleEmailTemplateChange}
              selectedEmailTemplate={selectedEmailTemplate}
              setSelectedEmailTemplate={setSelectedEmailTemplate}
              emailTemplates={emailTemplates}
              lastQuestion={lastQuestion}
              latestPurchase={latestPurchase}
              customer={customer}
              requestedLetterNotAdded={customerWaitingForLetter && noLetterAddedToReport}
            />
          </TabPanel>
        </div>
      </Tabs>
    </div>
  )
}
